export const formatTime = (s) =>{
  return s.replace(/00:/g, '').replace('000', '')
}